module.exports = __webpack_public_path__ + "images/Laser7.png";